import React from 'react';
import { SkeletonLoading } from '@saleshandy/design-system';

interface TaskListSkeletonProps {
  count?: number;
}

const TaskListSkeleton: React.FC<TaskListSkeletonProps> = ({ count = 4 }) => (
  <>
    {Array.from({ length: count }).map((_, index) => (
      <div
        key={`skeleton-${index}`}
        className="task-list-item"
        style={{
          display: 'flex',
          paddingTop: '12px',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
          borderRadius: '4px',
          border: '1px solid var(--gray-200, #E5E7EB)',
          background: 'var(--gray-white, #FFF)',
          marginBottom: '12px',
        }}
      >
        <div
          className="task-list-item-header"
          style={{
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingLeft: '16px',
            paddingRight: '16px',
            paddingBottom: '12px',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              flex: 1,
            }}
          >
            <SkeletonLoading width={20} height={20} />
            <SkeletonLoading
              width={177}
              height={20}
              style={{ borderRadius: '4px' }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <SkeletonLoading
              width={181}
              height={14}
              style={{ borderRadius: '4px' }}
            />
          </div>
        </div>
      </div>
    ))}
  </>
);

export default TaskListSkeleton;

